import { useState, useRef } from 'react';

const useThumbnailCarousel = ({ imageIds, priorityLimit, ...props }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const thumbnailsListRef = useRef(null);
  const selectedImageId = imageIds[selectedImageIndex];

  const mainImageButtonClick = next => {
    let newIndex;
    if (next) {
      const isLast = imageIds.length - 1 === selectedImageIndex;
      newIndex = isLast ? 0 : selectedImageIndex + 1;
    } else {
      const isFirst = selectedImageIndex === 0;
      newIndex = isFirst ? imageIds.length - 1 : selectedImageIndex - 1;
    }
    scrollToImage(newIndex);
  };

  const scrollToImage = newIndex => {
    if (thumbnailsListRef.current && selectedImageIndex !== newIndex) {
      thumbnailsListRef.current.scrollTo({
        left: 150 * newIndex,
        behavior: 'smooth'
      });
      setSelectedImageIndex(newIndex);
    }
  };

  return {
    ...props,
    imageIds,
    selectedImageId,
    selectedImageIndex,
    thumbnailsListRef,
    priorityLimit,
    scrollToImage,
    mainImageButtonClick
  };
};

export default useThumbnailCarousel;
